import React from 'react'

function ID3() {
    return (
        <div className="servicePage_item">
            <h2 className="servicePage_title">УПРАВЛЕНИЕ ТОРГОВЫМИ СЕТЯМИ</h2>
            <div className="content" readonly=""><h2>RS.ERP</h2>
                <div>Высокопроизводительное решение для управления розничной торговлей. Оптимизирует процессы
                    планирования ассортимента, ценообразования, управления запасами, производства и взаимоотношения с
                    поставщиками. Подходит ритейлерам любого размера и формата.<h2><br/></h2>
                    <div>
                        <div>Retail Suite.ERP — это специализированные отраслевые ERP решения для автоматизации
                            управления розничной торговлей в сегментах Grocery, FMCG, Droggery, DIY, Household и
                            Fashion.
                        </div>
                        <div>Автоматизация товародвижения в торговой сети позволит не тратить время на решение рутинных
                            задач, и сосредоточиться на повышении эффективности бизнеса.
                        </div>
                    </div>
                    <h2><br/></h2><h2>

                        Решаемые задачи</h2>
                    <div><br/></div>
                    <div><span
                        >Актуальность и корректность мастер данных</span><br/>
                    </div>
                    <div>
                        <div>В решении присутствуют все необходимые инструменты для организации единого центра ввода
                            мастер-данных. Система предотвращает ввод дублирующихся или неверно заполненных карточек
                            номенклатуры и других объектов. Корректные мастер-данные повышают точность аналитики,
                            достоверность прогнозов, качество заказов и обеспечивают корректность транзакционных данных
                            по всех звеньях системы РЦ-Торговые точки-Интернет Магазин.
                        </div>
                    </div>
                    <div><br/></div>
                    <div><span
                        >Исполнение и контроль ключевых процессов</span><br/>
                    </div>
                    <div>
                        <div>Автоматизация бизнес-процессов позволяет пользователю выстраивать элементарные операции в
                            управляемые логические цепочки с возможностью контроля текущего состояния каждого экземпляра
                            процесса В любой момент времени руководитель может получить информацию о выполняемых в
                            данный момент бизнес-процессах: на какой стадии находится каждый экземпляр процесса, кто из
                            пользователей в настоящий момент выполняет работу.
                        </div>
                    </div>
                    <h2><br/></h2><h2><br/></h2><h2>

                        Карта решения RS.ERP</h2>
                    <div><img src="https://cybernetica.kz/uploads/gallery/916705914.png" width="400px"/><br/></div>
                </div>
                <h2><br/></h2><h2><br/></h2><h2>


                    Все необходимое для корректного оперативного и складского учета</h2>
                <div><br/></div>
                <ul>
                    <li>Учет товародвижения по нескольким юридическим лицам.</li>
                    <li>Настраиваемые правила перепродажи товара между юридическими лицами.</li>
                    <li>Учет движения товаров между магазинами.</li>
                    <li>Учет деятельности неавтоматизированных розничных точек.</li>
                    <li>Учет движения товаров различного типа: товар, набор, комплект, готовая продукция, материал.</li>
                    <li>Учет операций сборки и разборки комплектов.</li>
                    <li>Учет возвратной и невозвратной тары.</li>
                    <li>Учет по любым дополнительным характеристикам товара: цвет, сорт, размер, и т.д.</li>
                    <li>Планирование инвентаризаций в сети.</li>
                    <li>Регистрация результатов инвентаризаций и устранение пересортиц.</li>
                    <li>Фиксация недостач при приходе товара.</li>
                    <li>Учет транспортных и прочих дополнительных услуг при поставке.</li>
                    <li>Учет сертификатов качества. Работа с ветеринарными сертификатами.</li>
                    <li>Контроль неотфактурованных поставок.</li>
                    <li>Учет номеров ГТД.</li>
                    <li>Возможность жесткого контроля ассортимента и закупочных цен поставщика.</li>
                    <li>Схема электронного документооборота EDI.</li>
                    <li>Анализ принимаемого товара на принадлежность к ассортиментной матрице.</li>
                    <li>Учет бонусных поставок.</li>
                    <li>Учет оборота алкогольной продукции. Обмен данными с ЕГАИС.</li>
                    <li>Работа с маркированным товаром.</li>
                    <li>Мастер возвратов поставщикам.</li>
                    <li>Резервирование товаров для покупателей.</li>
                    <li>Возможность в договоре с видом «Продажа» задействовать механизм контроля товарной
                        спецификации.
                    </li>
                    <li>Продажа подарочных сертификатов и последующая оплата ими товара.</li>
                    <li>Учет работ по гарантийному и сервисному обслуживанию.</li>
                </ul>
            </div>



        </div>
    )
}

export {ID3}
